var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_73",
    "data-name": "\\uADF8\\uB8F9 73",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_4",
    "data-name": "\\uADF8\\uB8F9 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1",
    "data-name": "\\uD328\\uC2A4 1",
    d: "M0,18.842C.067,8.012,7.861.638,16.571.05A17.607,17.607,0,0,1,30.761,5.3,17.232,17.232,0,0,1,35.909,16.19,17.5,17.5,0,0,1,30.952,30.5a17.3,17.3,0,0,1-12.23,5.489A17.439,17.439,0,0,1,5.129,30.572,17.162,17.162,0,0,1,0,18.842m31.638-.122a13.4,13.4,0,0,1-3.481,8.393,13.283,13.283,0,0,1-9.187,4.511,13.22,13.22,0,0,1-10.4-3.755A13.175,13.175,0,0,1,4.357,18.76,13.2,13.2,0,0,1,8.18,8.509,13.464,13.464,0,0,1,18.724,4.334v-1.4a15.08,15.08,0,1,0,6.95,28.036A14.882,14.882,0,0,0,31.8,24.08a15.379,15.379,0,0,0,1.275-6.749H22.324V18.72Zm-12.91,5.755V10.1H17.295V25.886h5V24.475ZM10.1,12.243A2.16,2.16,0,1,0,12,10.105a2.155,2.155,0,0,0-1.9,2.138",
    transform: "translate(0 0)",
    fill: "#c30036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M46.193,33.339H37.015V31.97h10.6a15.171,15.171,0,0,1-1.256,6.654,14.669,14.669,0,0,1-6.039,6.792,14.859,14.859,0,1,1-6.847-27.64v1.38A13.262,13.262,0,0,0,23.08,23.272a13.022,13.022,0,0,0-3.767,10.106,13.492,13.492,0,0,0,14.4,12.683,13.085,13.085,0,0,0,9.052-4.447,13.217,13.217,0,0,0,3.429-8.275",
    transform: "translate(-14.755 -14.63)",
    fill: "#fffefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M107.374,77.092h3.836v1.513h-5.378V61.672h1.542Z",
    transform: "translate(-88.749 -52.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M61.8,63.926a2.324,2.324,0,1,1,4.648.034,2.324,2.324,0,0,1-4.648-.034",
    transform: "translate(-51.809 -51.627)",
    fill: "#fffefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fd122e368a8430280b137e47e791d273.svg";
export { ForwardRef as ReactComponent };